import PropTypes from 'prop-types'
import * as React from 'react'
import { useSelector } from 'react-redux'
import SidebarInfoBasic from './SidebarInfoBasic'
import SidebarInfoTrendingHours from './SidebarInfoTredingHours'
import { selectSelectedAsset } from '../../../../../store/redusers/assets/selectors'

function SidebarInfo({ isBasicTab }) {
	const assetInfo = useSelector(selectSelectedAsset)
	return isBasicTab ? <SidebarInfoBasic assetInfo={assetInfo}/> : <SidebarInfoTrendingHours assetInfo={assetInfo}/>
}

SidebarInfo.propTypes = {
	isBasicTab: PropTypes.bool
}
export default SidebarInfo
